import type { FC } from 'react';
import KeyboardArrowDownRounded from '@mui/icons-material/KeyboardArrowDownRounded';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import {
  Box,
  IconButton,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material';

import { styles } from './index.styles';

const menuProps = {
  PaperProps: {
    sx: styles.menuProps,
  },
};

export interface TablePaginationProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (newPage: number) => void;
  rowsPerPageOptions: number[];
  onRowsPerPageChange: (newRowsPerPage: number) => void;
  labelRowsPerPage: string;
}

const TablePagination: FC<TablePaginationProps> = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
  rowsPerPageOptions,
  onRowsPerPageChange,
  labelRowsPerPage,
}) => {
  const totalPages = Math.ceil(count / rowsPerPage);

  const handlePreviousPage = () => {
    if (page > 0) {
      onPageChange(page - 1);
    }
  };

  const handleNextPage = () => {
    if (page < totalPages - 1) {
      onPageChange(page + 1);
    }
  };

  const startItem = page * rowsPerPage + 1;
  const endItem = Math.min((page + 1) * rowsPerPage, count);

  return (
    <Box sx={styles.paginationContainer}>
      <Stack direction="row" spacing={1} sx={styles.selectContainer}>
        <Typography variant="body3" sx={styles.label}>
          {labelRowsPerPage}
        </Typography>
        <Select
          value={rowsPerPage}
          onChange={(e) =>
            onRowsPerPageChange(parseInt(e.target.value as string, 10))
          }
          variant="outlined"
          sx={styles.selectDropdown}
          IconComponent={KeyboardArrowDownRounded}
          MenuProps={menuProps}
        >
          {rowsPerPageOptions.map((option) => (
            <MenuItem key={option} value={option} sx={styles.menuItem}>
              <Typography
                variant="body3"
                sx={{
                  fontWeight: 600,
                }}
              >
                {option}
              </Typography>
            </MenuItem>
          ))}
        </Select>
      </Stack>
      <Box sx={styles.paginationButtonsContainer}>
        <Typography variant="body3" sx={{ pr: 1, ...styles.label }}>
          {`${startItem}-${endItem} of ${count}`}
        </Typography>
        <IconButton
          disableRipple
          onClick={handlePreviousPage}
          disabled={page === 0}
        >
          <KeyboardArrowLeft />
        </IconButton>
        <IconButton
          disableRipple
          onClick={handleNextPage}
          disabled={page >= totalPages - 1}
        >
          <KeyboardArrowRight />
        </IconButton>
      </Box>
    </Box>
  );
};

export default TablePagination;
